// extracted by mini-css-extract-plugin
export var divider = "_jq-0";
export var systemMessage = "_jq-1";